// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonKeyAddOnSuccess_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="11" cy="11" r="5" fill="#29C192"/>
  <circle cx="11" cy="11" r="5" class="svg-fg-stroke"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5505 9.4295L13.3196 8.19206L9.97867 11.5508L8.39613 9.95983L7.16526 11.1973L8.7478 12.7883L9.97867 14.0257L11.2095 12.7883L14.5505 9.4295Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0572 6.57962C15.6454 5.88318 16 4.983 16 4C16 1.79086 14.2091 0 12 0C10.1362 0 8.57006 1.27477 8.12602 3H0V5H1V7H5V5H8.12602C8.1811 5.214 8.25344 5.42107 8.34148 5.61964C8.94174 5.32247 9.59886 5.1228 10.2921 5.04132C10.1068 4.738 10 4.38147 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4C14 4.58499 13.7488 5.11131 13.3485 5.47704C13.9811 5.7464 14.5581 6.1213 15.0572 6.57962Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonKeyAddOnSuccess is a generated icon component.
 */
let IconCommonKeyAddOnSuccess = IconCommonKeyAddOnSuccess_1 = class IconCommonKeyAddOnSuccess extends IconBaseElement {
    render() {
        return html `${IconCommonKeyAddOnSuccess_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonKeyAddOnSuccess.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonKeyAddOnSuccess = IconCommonKeyAddOnSuccess_1 = __decorate([
    customElement('zui-icon-common-key-add-on-success')
], IconCommonKeyAddOnSuccess);
export { IconCommonKeyAddOnSuccess };
